export default "__VITE_ASSET__nHxM_MsP__"